/**
 * @flow
 * @relayHash 9716c4e2559bf0403ccfa13324ebcf43
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSavedAreaFromGeographicEntityInput = {
  value: string,
  label: string,
  geographicUnit: string,
  clientMutationId?: ?string,
};
export type RootCreateAreaMutationVariables = {|
  input: CreateSavedAreaFromGeographicEntityInput
|};
export type RootCreateAreaMutationResponse = {|
  +createSavedAreaFromGeographicEntity: ?{|
    +savedAreaNode: ?{|
      +id: string
    |}
  |}
|};
export type RootCreateAreaMutation = {|
  variables: RootCreateAreaMutationVariables,
  response: RootCreateAreaMutationResponse,
|};
*/


/*
mutation RootCreateAreaMutation(
  $input: CreateSavedAreaFromGeographicEntityInput!
) {
  createSavedAreaFromGeographicEntity(input: $input) {
    savedAreaNode {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSavedAreaFromGeographicEntityInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createSavedAreaFromGeographicEntity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateSavedAreaFromGeographicEntityInput!"
      }
    ],
    "concreteType": "CreateSavedAreaFromGeographicEntityPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "savedAreaNode",
        "storageKey": null,
        "args": null,
        "concreteType": "SavedAreaNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "RootCreateAreaMutation",
  "id": null,
  "text": "mutation RootCreateAreaMutation(\n  $input: CreateSavedAreaFromGeographicEntityInput!\n) {\n  createSavedAreaFromGeographicEntity(input: $input) {\n    savedAreaNode {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "RootCreateAreaMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "RootCreateAreaMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ca1a0a235609b38890b8537bd8774edb';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Root/__generated__/RootCreateAreaMutation.graphql.js